import type { AlignType, JustifyType } from '../types';

const ALIGN_TO_FLEX: Record<NonNullable<AlignType>, string> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
  justify: 'flex-end',
  column_dynamic: 'flex-end',
};

const JUSTIFY_TO_FLEX: Record<JustifyType, string> = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
};

/** Maps UI alignment labels (left/center/right) to JustifyType values. */
export const JUSTIFY_VALUES = {
  left: 'start',
  center: 'center',
  right: 'end',
} as const satisfies Record<string, JustifyType>;

/** Default JustifyType value for alignment settings. */
export const JUSTIFY_DEFAULT: JustifyType = 'start';

export const computeAlignment = (alignment?: AlignType): string => {
  if (!alignment) return 'flex-start';
  return ALIGN_TO_FLEX[alignment] ?? 'flex-start';
};

/**
 * Converts JustifyType values to CSS flexbox justify-content values.
 * Returns undefined when input is undefined to allow CSS cascade.
 */
export const computeJustifyContent = (justify: JustifyType | undefined): string | undefined => {
  return justify ? JUSTIFY_TO_FLEX[justify] : undefined;
};
